import { render, staticRenderFns } from "./MoleculeEditionAcademyUsersDropDownActors.vue?vue&type=template&id=22ac456b&"
import script from "./MoleculeEditionAcademyUsersDropDownActors.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyUsersDropDownActors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports